import { useState, useCallback } from 'react';
import quarkusApi from '../../../../api/quarkusApi';

const authHeader = () => ({ headers: { Authorization: sessionStorage.getItem('token') } });

// DELETE de imagem e busca de URL no quarkus.
export function useImageActions() {
  const [isLoading, setLoading] = useState(false);

  const remove = useCallback((imageId) => {
    setLoading(true);
    return quarkusApi.delete(`/images/${imageId}`, authHeader()).finally(() => setLoading(false));
  }, []);

  const fetchUrl = useCallback((imageId) => {
    setLoading(true);
    return quarkusApi.get(`/images/${imageId}/url`, authHeader()).finally(() => setLoading(false));
  }, []);

  return { remove, fetchUrl, isLoading };
}
